<template>
  <DispatchConfigForm is-new />
</template>

<script>
import DispatchConfigForm from '../components/DispatchConfigForm.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import zonesStore from '@/views/zones/zoneStoreModule'
import dispatchStore from '../store'

export default {
  components: { DispatchConfigForm },
  setup() {
    useRegisterStoreModule('dispatch', dispatchStore)
    useRegisterStoreModule('zones', zonesStore)
  },
}
</script>

<style>

</style>
